const getCardTypeFromName = (c) => {
  if (c.toLowerCase() === 'mastercard' || c.toLowerCase() === 'mc')
    return { type: '5', name: 'MasterCard' };
  else if (c.toLowerCase() === 'american express' || c.toLowerCase() === 'amex')
    return { type: '2', name: 'American Express(Amex)' };
  else if (c.toLowerCase() === 'visa') return { type: '6', name: 'Visa' };
  else return { type: '1500', name: 'Unknown' };
};

export default getCardTypeFromName;
